import { Component } from "react";
import Select from "react-select";
import $ from "jquery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { adminlimit } from "../../Settings/Config";
import api from "../../../utils/axios";
import {
  showContaimerLoader,
  encodeValue,
  removeItem,
  showPageCount,
  removeChar,
  isEmpty,
  showLoader,
  hideLoader,
  showAlert,
  isSingleSelect,
  showDate,
  validateDate,
  apiDate,
  calculateYMD,
  hasPermission,
} from "../../Settings/Settings";
import Pagenation from "../../Layout/Pagenation";
const module = "candidateseaservice";
const modulePath = "/candidate";
const moduleName = "Sea Service";
const idName = "seaservice";
const moduleID = 26;
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageLimit: { label: adminlimit, value: adminlimit },
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      name: "",
      companyList: [],
      rankList: [],
      vesselList: [],
      vesselTypeList: [],
      editID: "",
      postdata: {
        company: "",
        company_other: "",
        rank: "",
        rank_other: "",
        vessel: "",
        vessel_other: "",
        type: "",
        type_other: "",
        from1: "",
        to1: "",
        total_MMDD: "",
        reason_for_sign_off: "",
        Flag: "",
        KWT: "",
        GRT: "",
        Engine: "",
        DWT: "",
      },
      detaildata: [],
      restForm: false,
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    this.loadList(1);
    this.loadDropdown();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader(`submit_${idName}_frm`);
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
  }
  searchList(e) {
    e.preventDefault();
    this.setState({ loading: true, currentPage: 1 }, () => {
      this.loadList(1);
    });
  }
  resetSearch(e) {
    e.preventDefault();
    this.setState(
      {
        loading: true,
        name: "",
        currentPage: 1,
      },
      () => {
        this.loadList(1);
      },
    );
  }
  loadList(offset) {
    this.setState({ loading: true });
    let addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }

    try {
      api
        .get(`${module}?limit=${this.state.pageLimit.value}&offset=${offset}&candidateId=${this.props.candidateID}${addParams}`)
        .then((res) => {
          if (res.data.status === "ok") {
            this.setState({ listdata: res.data.result, loading: false, totalRecords: res.data.totalRecords, totalPage: res.data.totalPages });
          }
        })
        .catch((err) => {
          console.error(err);
          this.setState({ loading: false, totalRecords: 0, totalPage: 0, currentPage: 1, listdata: [] });
        });
    } catch (e) {
      this.setState({ loading: false, totalRecords: 0, totalPage: 0, currentPage: 1, listdata: [] });
    }
  }
  loadDropdown() {
    api
      .get("company/dropdownname")
      .then((res) => {
        if (res.data.status === "ok") {
          let result = res.data.result;
          result.push({ label: "Others", value: "Others" });
          this.setState({ companyList: result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("rank/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          let result = res.data.result;
          result.push({ label: "Others", value: "Others" });
          this.setState({ rankList: result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("vessel/dropdownname")
      .then((res) => {
        if (res.data.status === "ok") {
          let result = res.data.result;
          result.push({ label: "Others", value: "Others" });
          this.setState({ vesselList: result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("vesseltype/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          let result = res.data.result;
          result.push({ label: "Others", value: "Others" });
          this.setState({ vesselTypeList: result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  edit(editID, e) {
    e.preventDefault();
    this.setState({ editID: editID }, () => {
      api
        .get(`${module}/detail/${encodeValue(editID)}`)
        .then((res) => {
          if (res.data.status === "ok") {
            $(`#addNew${idName}`).trigger("click");
            const result = res.data.result;

            let company = result.company ?? "Others";
            let company_other = "";
            if (company === "Others") {
              company_other = result.company_other;
            }

            let rank = result.rank ?? "Others";
            let rank_other = "";
            if (rank === "Others") {
              rank_other = result.rank_other;
            }

            let vessel = result.vessel ?? "Others";
            let vessel_other = "";
            if (vessel === "Others") {
              vessel_other = result.vessel_other;
            }

            let type = result.type ?? "Others";
            let type_other = "";
            if (type === "Others") {
              type_other = result.type_other;
            }

            this.setState({
              postdata: {
                company: { label: company, value: company },
                company_other: company_other,
                rank: { label: rank, value: rank },
                rank_other: rank_other,
                vessel: { label: vessel, value: vessel },
                vessel_other: vessel_other,
                type: { label: type, value: type },
                type_other: type_other,
                from1: validateDate(result.from1),
                to1: validateDate(result.to1),
                total_MMDD: result.total_MMDD || "",
                reason_for_sign_off: result.reason_for_sign_off || "",
                Flag: result.Flag || "",
                KWT: result.KWT || "",
                GRT: result.GRT || "",
                Engine: result.Engine || "",
                DWT: result.DWT || "",
              },
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    });
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        () => {
          this.loadList(value);
        },
      );
    } else if (field === "pageLimit") {
      this.setState({ pageLimit: value, currentPage: 1 }, () => {
        this.loadList(1);
      });
    } else if (field === "restForm") {
      this.setState({ restForm: value });
    }
  };
  handleChangeText(event) {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  removeItem(deleteID, e) {
    e.preventDefault();
    removeItem(deleteID, module, this.sateValChange, this.state.currentPage);
  }

  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: removeChar(value) } } }));
  };

  handleSubmit = () => {
    showLoader(`submit_${idName}_frm`);
    const postData = this.state.postdata;
    let company = postData.company?.value ?? "Others";
    if (company === "Others") {
      company = postData.company_other.toUpperCase();
    }

    let rank = postData.rank?.value ?? "Others";
    if (rank === "Others") {
      rank = postData.rank_other.toUpperCase();
    }
    let vessel = postData.vessel?.value ?? "Others";
    if (vessel === "Others") {
      vessel = postData.vessel_other.toUpperCase();
    }
    let type = postData.type?.value ?? "Others";
    if (type === "Others") {
      type = postData.type_other.toUpperCase();
    }

    const postObject = {
      candidateId: this.props.candidateID,
      company,
      rank,
      vessel,
      type,
      from1: apiDate(postData.from1),
      to1: apiDate(postData.to1),
      total_MMDD: postData.total_MMDD.toUpperCase(),
      reason_for_sign_off: postData.reason_for_sign_off.toUpperCase(),
      Flag: postData.Flag.toUpperCase(),
      KWT: postData.KWT.toUpperCase(),
      GRT: postData.GRT.toUpperCase(),
      Engine: postData.Engine.toUpperCase(),
      DWT: postData.DWT.toUpperCase(),
    };

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${encodeValue(this.state.editID)}`;
      method = "put";
    }
    api[method](post_url, postObject)
      .then((res) => {
        hideLoader(`submit_${idName}_frm`);
        $(".btn-close").trigger("click");
        const errMsg = res.data.message;
        if (res.data.status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.loadList(1);
          setTimeout(() => {
            this.resetFrom();
          }, 1000);
        }
      })
      .catch((err) => {
        hideLoader(`submit_${idName}_frm`);
        const errMsg = err.response.data?.message || err?.message;
        showAlert("Error", errMsg, "error", "No");
        console.error(err);
      });
  };
  closePopup() {
    setTimeout(() => {
      this.resetFrom();
    }, 1000);
  }
  resetFrom() {
    this.setState({
      editID: "",
      restForm: true,
      postdata: {
        company: "",
        company_other: "",
        rank: "",
        rank_other: "",
        vessel: "",
        vessel_other: "",
        type: "",
        type_other: "",
        from1: "",
        to1: "",
        total_MMDD: "",
        reason_for_sign_off: "",
        Flag: "",
        KWT: "",
        GRT: "",
        Engine: "",
        DWT: "",
      },
    });
  }

  render() {
    return (
      <div className="main-container container-fluid mx-3">
        <div className="page-header">
          <h1 className="page-title">{moduleName} Details</h1>
          <div>
            {hasPermission(moduleID, "add") && (
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <button
                    className="btn btn-sm btn-success badge mx-4"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target={`#${idName}modal`}
                    data-backdrop="static"
                    data-keyboard="false"
                    id={`addNew${idName}`}
                  >
                    <i className="fa fa-plus"></i> Add New
                  </button>
                </li>
              </ol>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="form-row">
                  <div className="col-md-3">
                    <input type="text" className="form-control" placeholder={"Search keyword"} name="name" onChange={this.handleChangeText} value={this.state.name} />
                  </div>
                  <div className="col-md-3">
                    <a href="/" className="btn btn-primary" onClick={this.searchList.bind(this)}>
                      Search
                    </a>
                    <a href="/" className="btn btn-secondary offset-1" onClick={this.resetSearch.bind(this)}>
                      Reload
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              {this.state.loading ? (
                showContaimerLoader()
              ) : (
                <div>
                  <div className="card-header">
                    {parseInt(this.state.totalPage) > 0 && showPageCount(moduleName, this.state.currentPage, this.state.totalPage, this.state.totalRecords, this.sateValChange, this.state.pageLimit)}
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                        <thead className="table-primary">
                          <tr>
                            {(hasPermission(moduleID, "edit") || hasPermission(moduleID, "delete")) && <th className="text-center">Actions </th>}
                            <th>S.No.</th>
                            <th>Company</th>
                            <th>Rank</th>
                            <th>Vessel</th>
                            <th>Vessel Type</th>
                            <th>From Date</th>
                            <th>To Date</th>
                            <th>Total Days</th>
                            <th>Reason for Sign Off</th>
                            <th>Flag</th>
                            <th>KWT</th>
                            <th>GRT</th>
                            <th>Engine</th>
                            <th>DWT</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.listdata.length > 0 ? (
                            this.state.listdata.map((item, index) => {
                              return (
                                <tr key={index}>
                                  {(hasPermission(moduleID, "edit") || hasPermission(moduleID, "delete")) && (
                                    <td className="text-center text-nowrap" valign="top">
                                      {hasPermission(moduleID, "edit") && (
                                        <a href="/" onClick={this.edit.bind(this, item.id)} className="me-2">
                                          <i className="fa fa-pencil-square-o"></i>
                                        </a>
                                      )}
                                      {hasPermission(moduleID, "delete") && (
                                        <a href="/" className="delete_record" onClick={this.removeItem.bind(this, encodeValue(item.id))}>
                                          <i className="fa fa-trash"></i>
                                        </a>
                                      )}
                                    </td>
                                  )}
                                  <td>{(parseInt(this.state.currentPage) - 1) * parseInt(this.state.pageLimit.value) + (parseInt(index) + 1)}</td>
                                  <td>{item.company}</td>
                                  <td>{item.rank}</td>
                                  <td>{item.vessel}</td>
                                  <td>{item.type}</td>
                                  <td>{showDate(item.from1)}</td>
                                  <td>{showDate(item.to1)}</td>
                                  <td>{item.total_MMDD}</td>
                                  <td>{item.reason_for_sign_off}</td>
                                  <td>{item.Flag}</td>
                                  <td>{item.KWT}</td>
                                  <td>{item.GRT}</td>
                                  <td>{item.Engine}</td>
                                  <td>{item.DWT}</td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td className="text-center" colSpan={15}>
                                No {moduleName} Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {parseInt(this.state.totalPage) > 1 && (
                      <Pagenation
                        params={{
                          totalRecords: this.state.totalRecords,
                          totalPage: this.state.totalPage,
                          currentPage: this.state.currentPage,
                        }}
                        sateValChange={this.sateValChange}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="modal fade" id={`${idName}modal`} tabIndex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{`${this.state.editID !== "" ? "Update" : "Add New"} ${moduleName}`}</h5>
                <button className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.closePopup.bind(this)}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <PostForm
                {...this.props}
                fields={this.state.postdata}
                companyList={this.state.companyList}
                rankList={this.state.rankList}
                vesselList={this.state.vesselList}
                vesselTypeList={this.state.vesselTypeList}
                restForm={this.state.restForm}
                sateValChange={this.sateValChange}
                onChange={this.fieldChange}
                onValid={this.handleSubmit}
                closePopup={this.closePopup.bind(this)}
                editID={this.state.editID}
                error_msg={this.state.error_msg}
                onInvalid={() => {
                  console.log("Form invalid!");
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default List;

const areSame = (filed1, filed2) => (filed1?.value === "Others" && filed2 === "" ? "This field is required." : null);
function validationConfig(props) {
  const { company, company_other, rank, rank_other, vessel, vessel_other, type, type_other, from1, to1, reason_for_sign_off } = props.fields;

  return {
    fields: ["company", "company_other", "rank", "rank_other", "vessel", "vessel_other", "type", "type_other", "from1", "to1", "reason_for_sign_off"],
    validations: {
      company: [[isSingleSelect, company]],
      company_other: {
        rules: [[areSame, company, company_other]],
        fields: ["company", "company_other"],
      },
      rank: [[isSingleSelect, rank]],
      rank_other: {
        rules: [[areSame, rank, rank_other]],
        fields: ["rank", "rank_other"],
      },
      vessel: [[isSingleSelect, vessel]],
      vessel_other: {
        rules: [[areSame, vessel, vessel_other]],
        fields: ["vessel", "vessel_other"],
      },
      type: [[isSingleSelect, type]],
      type_other: {
        rules: [[areSame, type, type_other]],
        fields: ["type", "type_other"],
      },
      from1: [[isEmpty, from1]],
      to1: [[isEmpty, to1]],
      reason_for_sign_off: [[isEmpty, reason_for_sign_off]],
    },
  };
}
class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      restData: false,
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.restForm === true) {
      this.props.sateValChange("restForm", false);
      setTimeout(() => {
        this.handleReset();
      }, 1000);
    }
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
    if (name === "from1" || name === "to1") {
      const from1 = (name === "from1")?value:this.props.fields.from1;
      const to1 = (name === "to1")?value:this.props.fields.to1;
      const totalDays = calculateYMD(from1, to1);
      console.log(totalDays, this.props.fields.from1, this.props.fields.to1, 'totalDaystotalDaystotalDays')
      setTimeout(() => {
        this.props.onChange("total_MMDD", totalDays);
      }, 1000);
    }
  }
  handleChangeFile(name, value) {
    this.props.onChange(name, value);
  }
  handleFileChange = (e) => {
    const file = e.target.files[0];
    const name = e.target.name;
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      this.props.onChange(name, previewUrl);
    }
  };
  closePopup() {
    this.props.sateValChange("restForm", true);
  }
  handleReset = () => {
    const { $validation } = this.props;
    // 2️⃣ Reset all validation errors
    Object.keys($validation).forEach((key) => {
      if ($validation[key]) {
        $validation[key].show = false;
        $validation[key].error = {};
      }
    });
    this.setState({ restData: this.state.restData });
  };

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgcompany,
      errMsgcompany_other,
      errMsgrank,
      errMsgrank_other,
      errMsgvessel,
      errMsgvessel_other,
      errMsgtype,
      errMsgtype_other,
      errMsgfrom1,
      errMsgto1,
      errMsgreason_for_sign_off = "";
    if ($validation.company.error.reason !== undefined) {
      errMsgcompany = $validation.company.show && <span className="error">{$validation.company.error.reason}</span>;
    }
    if ($validation.company_other.error.reason !== undefined) {
      errMsgcompany_other = $validation.company_other.show && <span className="error">{$validation.company_other.error.reason}</span>;
    }
    if ($validation.rank.error.reason !== undefined) {
      errMsgrank = $validation.rank.show && <span className="error">{$validation.rank.error.reason}</span>;
    }
    if ($validation.rank_other.error.reason !== undefined) {
      errMsgrank_other = $validation.rank_other.show && <span className="error">{$validation.rank_other.error.reason}</span>;
    }
    if ($validation.vessel.error.reason !== undefined) {
      errMsgvessel = $validation.vessel.show && <span className="error">{$validation.vessel.error.reason}</span>;
    }
    if ($validation.vessel_other.error.reason !== undefined) {
      errMsgvessel_other = $validation.vessel_other.show && <span className="error">{$validation.vessel_other.error.reason}</span>;
    }
    if ($validation.type.error.reason !== undefined) {
      errMsgtype = $validation.type.show && <span className="error">{$validation.type.error.reason}</span>;
    }
    if ($validation.type_other.error.reason !== undefined) {
      errMsgtype_other = $validation.type_other.show && <span className="error">{$validation.type_other.error.reason}</span>;
    }
    if ($validation.from1.error.reason !== undefined) {
      errMsgfrom1 = $validation.from1.show && <span className="error">{$validation.from1.error.reason}</span>;
    }
    if ($validation.to1.error.reason !== undefined) {
      errMsgto1 = $validation.to1.show && <span className="error">{$validation.to1.error.reason}</span>;
    }
    if ($validation.reason_for_sign_off.error.reason !== undefined) {
      errMsgreason_for_sign_off = $validation.reason_for_sign_off.show && <span className="error">{$validation.reason_for_sign_off.error.reason}</span>;
    }

    return (
      <>
        <div>
          <div className="modal-body">
            <div className="form-group">
              <div className="form-row">
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Company<span className="lbl-error">*</span>
                  </label>
                  <Select value={fields.company} onChange={this.handleSelectChange.bind(this, "company")} placeholder="Select Company" options={this.props.companyList} />
                  {errMsgcompany}
                </div>
                {fields.company?.value === "Others" && (
                  <div className="form-group col-md-3">
                    <label className="form-label">
                      Other Company<span className="lbl-error">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control upper-case"
                      placeholder="Other Company"
                      name="company_other"
                      value={fields.company_other}
                      {...$field("company_other", (e) => onChange("company_other", e.target.value))}
                    />
                    {errMsgcompany_other}
                  </div>
                )}
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Rank<span className="lbl-error">*</span>
                  </label>
                  <Select value={fields.rank} onChange={this.handleSelectChange.bind(this, "rank")} placeholder="Select Rank" options={this.props.rankList} />
                  {errMsgrank}
                </div>
                {fields.rank?.value === "Others" && (
                  <div className="form-group col-md-3">
                    <label className="form-label">
                      Other Rank<span className="lbl-error">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control upper-case"
                      placeholder="Other Rank"
                      name="rank_other"
                      value={fields.rank_other}
                      {...$field("rank_other", (e) => onChange("rank_other", e.target.value))}
                    />
                    {errMsgrank_other}
                  </div>
                )}
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Vessel<span className="lbl-error">*</span>
                  </label>
                  <Select value={fields.vessel} onChange={this.handleSelectChange.bind(this, "vessel")} placeholder="Select Vessel" options={this.props.vesselList} />
                  {errMsgvessel}
                </div>
                {fields.vessel?.value === "Others" && (
                  <div className="form-group col-md-3">
                    <label className="form-label">
                      Other Vessel<span className="lbl-error">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control upper-case"
                      placeholder="Other Vessel"
                      name="vessel_other"
                      value={fields.vessel_other}
                      {...$field("vessel_other", (e) => onChange("vessel_other", e.target.value))}
                    />
                    {errMsgvessel_other}
                  </div>
                )}

                <div className="form-group col-md-3">
                  <label className="form-label">
                    Vessel Type<span className="lbl-error">*</span>
                  </label>
                  <Select value={fields.type} onChange={this.handleSelectChange.bind(this, "type")} placeholder="Select Vessel Type" options={this.props.vesselTypeList} />
                  {errMsgtype}
                </div>
                {fields.type?.value === "Others" && (
                  <div className="form-group col-md-3">
                    <label className="form-label">
                      Other Vessel Type<span className="lbl-error">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control upper-case"
                      placeholder="Other Vessel Type"
                      name="type_other"
                      value={fields.type_other}
                      {...$field("type_other", (e) => onChange("type_other", e.target.value))}
                    />
                    {errMsgtype_other}
                  </div>
                )}

                <div className="form-group col-md-3">
                  <label className="form-label">
                    From Date<span className="lbl-error">*</span>
                  </label>
                  <DatePicker
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="Select From Date"
                    className="form-control"
                    onKeyDown={(e) => e.preventDefault()}
                    selected={fields.from1}
                    dateFormat="dd-MM-yyyy"
                    onChange={this.handleSelectChange.bind(this, "from1")}
                    maxDate={new Date()}
                  />
                  {errMsgfrom1}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">
                    To Date<span className="lbl-error">*</span>
                  </label>
                  <DatePicker
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="Select To Date"
                    className="form-control"
                    onKeyDown={(e) => e.preventDefault()}
                    selected={fields.to1}
                    dateFormat="dd-MM-yyyy"
                    onChange={this.handleSelectChange.bind(this, "to1")}
                    minDate={fields.from1 !== "" ? fields.from1 : ""}
                    maxDate={new Date()}
                  />
                  {errMsgto1}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">Total Days</label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Total Days"
                    name="total_MMDD"
                    value={fields.total_MMDD}
                    {...$field("total_MMDD", (e) => onChange("total_MMDD", e.target.value))}
                  />
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">Reason for Sign Off</label>
                  <input
                    type="text"
                    className="form-control upper-case"
                    placeholder="Reason for Sign Off"
                    name="reason_for_sign_off"
                    value={fields.reason_for_sign_off}
                    {...$field("reason_for_sign_off", (e) => onChange("reason_for_sign_off", e.target.value))}
                  />
                  {errMsgreason_for_sign_off}
                </div>

                <div className="form-group col-md-3">
                  <label className="form-label">Flag</label>
                  <input type="text" className="form-control upper-case" placeholder="Flag" name="Flag" value={fields.Flag} {...$field("Flag", (e) => onChange("Flag", e.target.value))} />
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">KWT</label>
                  <input type="text" className="form-control upper-case" placeholder="KWT" name="KWT" value={fields.KWT} {...$field("KWT", (e) => onChange("KWT", e.target.value))} />
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">GRT</label>
                  <input type="text" className="form-control upper-case" placeholder="GRT" name="GRT" value={fields.GRT} {...$field("GRT", (e) => onChange("GRT", e.target.value))} />
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">Engine</label>
                  <input type="text" className="form-control upper-case" placeholder="Engine" name="Engine" value={fields.Engine} {...$field("Engine", (e) => onChange("Engine", e.target.value))} />
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">DWT</label>
                  <input type="text" className="form-control upper-case" placeholder="DWT" name="DWT" value={fields.DWT} {...$field("DWT", (e) => onChange("DWT", e.target.value))} />
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" data-bs-dismiss="modal" onClick={this.closePopup.bind(this)}>
              Close
            </button>
            <button
              className="btn btn-primary"
              id={`submit_${idName}_frm`}
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Save changes
            </button>
          </div>
        </div>
      </>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
